<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteProductoCodigoRastreo"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionProductTrackingCodesModalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>
          {{ $t('mEditionProductTrackingCodesModalDelete.messageDelete.element') }}
          <b>{{ $modal.element.nombre }}</b>
          {{ $t('mEditionProductTrackingCodesModalDelete.messageDelete.options') }}
        </p>
        <small class="text-color-danger">
            {{ $t('mEditionProductTrackingCodesModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionProductTrackingCodesModalDelete.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductTrackingCodesModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductTrackingCodesModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  methods: {
    deleteProductoCodigoRastreo () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('producto', 'deleteProductoCodigoRastreo', {}, [this.$route.params.id, this.$modal.element.id_producto_codigo_rastreo])
          .then(response => {
            this.$modal.updateData('readElement')
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionProductTrackingCodesModalDelete', 'deleteProductoCodigoRastreo', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductTrackingCodesModalDelete', 'deleteProductoCodigoRastreo', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
